// extracted by mini-css-extract-plugin
module.exports = {"container":"HomeRankedKeywordsTitle_container__P69G0","arrow":"HomeRankedKeywordsTitle_arrow__AbS2u"};